import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../../Component/Topbar/Topbar";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { URLS } from "../../redux/api/Constants";
import { get, post } from "../../redux/api/ApiHandler";
import toast from "react-hot-toast";

const SpareAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type; // "add" | "edit" | "view"
  const isViewMode = formType === "view";
  const isEditMode = formType === "edit";
  const type = location.state.type;
  const id = location?.state?.id;
  const data = location?.state?.data;

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      sparename: "",
      itemcode: "",
      status: "Active",
    },
  });



  const addAdmin = async () => {
    const values = getValues(); // 👈 get all form field values

    let payload = {
      name: values.sparename,
      code: values.itemcode,
      type: 4,
      status: 1,
    };
    if (type == "add") {
      let res = await post(URLS.MASTERADD, payload)
      if (res?.status == "success") {
        toast.success(res?.message);
        navigate("/spare-type");
      }
    } else {
      let res = await post(URLS.MASTERUPDATE + id, payload)
      if (res?.status == "success") {
        toast.success(res?.message);
        navigate("/spare-type");
      }
    }
    console.log("Payload:", payload);
  };





  useEffect(() => {
    if (type != "add") {
      setValue("sparename", data?.name);
      setValue("itemcode", data?.code);

    }
  }, [])


  const onSubmit = (data) => {
    addAdmin(data)
    console.log("Submitted Data:", data);
    if (isEditMode) {
      console.log("Updating Spare...");
    } else {
      console.log("Adding new Spare...");
    }
    // navigate("/spare-type"); // ✅ redirect back to Spare list
  };

  return (
    <div>
      <Topbar
        header="Super Admin"
        subHead={isViewMode ? "View" : isEditMode ? "Edit" : "Add"}
      />
      <div className="container_fluit1 px-4 py-3">
        <form
          className="d-flex flex-wrap gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* Employee ID */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="sparename"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Spare Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Spare Name"
                    disabled={isViewMode}
                  />
                  {errors.sparename && (
                    <p style={{ color: "red" }}>{errors.sparename.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* Employee Name */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="itemcode"
              rules={{ required: "Employee Name is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Item Code <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Spare ID"
                    disabled={isViewMode}
                  />
                  {errors.itemcode && (
                    <p style={{ color: "red" }}>
                      {errors.itemcode.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>


        </form>

        {/* Buttons */}
        <div className="d-flex col-md-11 button_submit ac-jb my-3">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="back_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20"
          >
            Back
          </button>
          {!isViewMode && (
            <button
              type="submit"
              onClick={handleSubmit(onSubmit)}
              className="Add_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20"
            >
              {isEditMode ? "Save" : "Submit"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SpareAdd;
